import React, {useState} from 'react'
import {connect} from 'react-redux'
import {
    Card,
    CardContent,
    Typography,
    ClickAwayListener,
    Paper,
    Link,
} from '@material-ui/core'
import HelpContentDeptAdmin from './HelpContentDeptAdmin'
import HelpContentDeptCreator from './HelpContentDeptCreator'
import HelpContentEveryone from './HelpContentEveryone'
import {makeStyles} from '@material-ui/core/styles'

import IconButton from '@material-ui/core/IconButton'

const useStyles = makeStyles(theme => ({
    paper: {
        position: 'absolute',
        top: 48,
        right: 40,
        borderRadius: '0px',
        width: '460px',
        maxHeight: '80vh',
        overflow: 'auto',
        whiteSpace: 'normal',
        [theme.breakpoints.down('sm')]: {
            maxWidth: '320px',
            maxHeight: '75vh',
            right: 0,
        },
    },
    circle: {
        boxSizing: 'border-box',
        borderRadius: '50%',
        backgroundColor: theme.palette.common.white,
        height: '38px',
        width: '38px',
        padding: '1px 1px 1px 1px',
        '&:hover': {
            opacity: 0.8,
            backgroundColor: theme.palette.common.white,
            transition: 'border-color 0.2s, border-width 0.2s',
        },
    },
    helpsubheader: {
        fontWeight: theme.typography.body1.bold.fontWeight,
    },
    text: {
        alignItems: 'flex-start',
        font: 'Regular 0.8125rem/1.1875rem Montserrat',
        letterSpacing: 0,
        color: '#262626',
        opacity: 1,
    },
}))

const HelpButton = props => {
    const classes = useStyles()
    const {userrole} = props
    const [open, setOpen] = useState(false)
    const [expanded, setExpanded] = useState(false)

    const handleClick = () => {
        setOpen(!open)
    }

    const handleClose = () => {
        setOpen(false)
    }

    const handleChange = panel => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false)
    }

    return (
        <>
            <ClickAwayListener onClickAway={handleClose}>
                <div>
                    <IconButton
                        id="help-menu"
                        aria-controls="help-menu"
                        aria-haspopup="true"
                        className={classes.circle}
                        size="small"
                        onClick={handleClick}
                    >
                        <Typography variant="h6" align="center">
                            ?
                        </Typography>
                    </IconButton>

                    {open ? (
                        <Paper className={classes.paper}>
                            <div>
                                <Card>
                                    <CardContent>
                                        <Typography variant="h6">
                                            Get Help
                                        </Typography>
                                        <Typography variant="body1">
                                            If you experience technical issues
                                            with this application, please
                                            contact the&nbsp;
                                            <Link
                                                href="mailto:ucd3@untsystem.edu"
                                                rel="noreferrer noopener"
                                            >
                                                User-Centered Design,
                                                Development and Delivery team at
                                                ucd3@untsystem.edu
                                            </Link>
                                        </Typography>
                                    </CardContent>
                                </Card>
                                <HelpContentEveryone
                                    expanded={expanded}
                                    handleChange={handleChange}
                                />
                                {[
                                    'Super Admin',
                                    'Department Admin',
                                    'Department Creator',
                                ].includes(userrole) ? (
                                    <HelpContentDeptCreator
                                        expanded={expanded}
                                        handleChange={handleChange}
                                    />
                                ) : null}
                                {['Super Admin', 'Department Admin'].includes(
                                    userrole
                                ) ? (
                                    <HelpContentDeptAdmin
                                        expanded={expanded}
                                        handleChange={handleChange}
                                    />
                                ) : null}
                            </div>
                        </Paper>
                    ) : null}
                </div>
            </ClickAwayListener>
        </>
    )
}

function mapStateToProps(state) {
    return {
        roles: state.authentication.roles,
        superadmin: state.authentication.admin,
        activedepartment: state.departmentsdata.activedepartment,
    }
}

export default connect(mapStateToProps, null)(HelpButton)
